<template>
<div class="addy-result" :class="addyHighlight">
    <div class="cover-container col-lg-3 col-md-4">
        <a :rel="advert.body.length < 50 ? 'nofollow' : ''" :href="advert.url" class="coverimage-header-top coverimage-header-listing site-bg coverimage-header-with-logo" :style="headerStyle">
            <div class="coverimage-logo-wrapper">
                <avatar :user="advert.user" :scale="70" :showRequestPhoto="false" v-miniprofile="advert.user.id"></avatar>
            </div>
            <h1 class="coverimage-text-wrapper">
                <a :href="advert.user.links.profile" v-miniprofile="advert.user.id" class="coverimage-text">
                    {{ advert.user.userName }}
                </a>
                <span class="coverimage-text-icons">
                    <i class="fa fa-check-square is-verified is-verified-tall" v-if="advert.user.isVerified"
                        :title="gt.common.verified.replace('%username', advert.user.userName)"></i>
                    <i v-for="(person, index) in advert.user.persons" :key="index" class="fa fa-user" :class="person.genderClass"></i>
                </span>
            </h1>
        </a>
    </div>
    <div v-if="!isMobile" class="col-lg-9 col-md-8 addy-result-body">
        <a :rel="advert.body.length < 50 ? 'nofollow' : ''" :href="advert.url">
            <h2 class="addy-title">{{ advert.title }}</h2>
            <div class="row">
                <div class="col-sm-10">
                    <div class="addy-text">
                        {{ advert.body }}
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="addy-right-side">
                        <meet-logo v-if="advert.isMeet" :class="{ 'clearfix': !isMobile }"></meet-logo>
                        <extras-logo v-if="advert.user.hasExtras && advertsHighlight"></extras-logo>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </a>
    </div>
    <div v-if="isMobile" class="addy-result-body">
        <a :rel="advert.body.length < 50 ? 'nofollow' : ''" :href="advert.url">
            <h2 class="addy-title">{{ advert.title }}</h2>
            <div class="addy-text">
                {{ advert.body }}
            </div>
        </a>
    </div>
    <footer class="">
        <div class="col-sm-8">
            <div class="addy-result-location addy-category" :title="advert.location">
                <i class="fa fa-map-marker"></i>
                {{ advert.location }}
            </div>
        </div>
        <div class="col-sm-4">
            <div class="addy-time">
                <time>
                    <template v-if="advert.isMeet">{{ advert.meetTime }}</template>
                    <template v-else>{{ advert.updated }}</template>
                </time>
            </div>
        </div>
        <div class="clearfix"></div>
    </footer>
</div>
</template>

<script>
import dropdownDirective from 'Site/directive/dropdown';
import miniprofileDirective from 'Profile/directive/miniprofile';
import ExtrasLogo from 'Site/component/ExtrasLogo.vue';
import MeetLogo from 'Adverts/component/MeetLogo.vue';
import randomNumber from 'Site/js/util/random';
import Avatar from 'Profile/component/Avatar.vue';
import { mapState } from 'vuex';

export default {
    name: 'AdvertCard',
    computed: {
        ...mapState(['gt', 'isMobile']),
        addyHighlight() {
            return this.advert.user.hasExtras && this.advertsHighlight ? `addy-highlight-${randomNumber(1, 10)}` : '';
        },
        headerBackground() {
            if (window.innerWidth > 1100 && this.advert.coverLarge) {
                return this.advert.coverLarge;
            }
            if (window.innerWidth > 600 && this.advert.coverMedium) {
                return this.advert.coverMedium;
            }
            return this.advert.cover;
        },
        headerStyle() {
            return `background-image: url(${this.headerBackground})`;
        }
    },
    components: {
        ExtrasLogo,
        MeetLogo,
        Avatar
    },
    directives: {
        dropdown: dropdownDirective,
        miniprofile: miniprofileDirective
    },
    props: {
        advert: {
            type: Object,
            required: true
        },
        advertsHighlight: {
            type: Boolean,
            default: false
        },
        t: {
            type: Object,
            default() {
                return this.$store.state.t;
            }
        }
    }
};

</script>
